<template>
  <sl-screen 
    pagetype=0 
    pagename=""
    :title="$t('sl.itandxpdigitale.title') "
    titlecolor=""
  />
</template>

<script>
import Vue from 'vue';
import SlScreen from '@/views/Layout/SlScreen';

  export default {
    name: 'it-digital-experience',
    components: {
      SlScreen
    },
     data() {
      return {
      };
    },
  };
</script>
